module.exports = __webpack_public_path__ + "img/hamle-eng.5143bda6.webp";